import { useEffect, useState } from "react";

export const HSRegisterForm = () => {
    const [isLoading, setIsLoading] = useState(true)


    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://js.hsforms.net/forms/embed/v2.js';
        document.body.appendChild(script);
        script.addEventListener('load', () => {
            if (window.hbspt) {
                setIsLoading(false)
                window.hbspt.forms.create({
                    region: "na1",
                    portalId: "536350",
                    formId: "8b0104df-57bf-4a46-bef7-b8e2b9fad4d1",
                    target: '#contactForm',
                })
            }
        });
    }, []);

    return (
        <div className='hs-register-form'>
            {isLoading && <div id="loader"></div>}
            {!isLoading && <div id="contactForm" />}
        </div>
    );
};